import React from "react";
import { PageShell } from "../components/PageShell";

export default function WenInstructiesPage() {
  return (
    <PageShell title="Inloopinstructies">
      <div data-testid="wen-instructies" className="prose prose-sm max-w-none text-slate-800">
        <h1 className="text-2xl font-semibold sm:text-3xl">Inloopinstructies voor uw nieuwe steunzolen</h1>
        <p className="mt-3 text-sm text-slate-700 sm:text-base">
          Uw nieuwe steunzolen van Fulkra Works moeten ingelopen worden om ze optimaal te laten functioneren.
          Volg onderstaand schema in de eerste 14 dagen.
        </p>

        <div className="mt-5 overflow-hidden rounded-lg border border-slate-200 bg-slate-50">
          <div className="relative pb-[56.25%]">
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-slate-100 px-4 text-center text-slate-500">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-12 w-12">
                <path d="M8 5v14l11-7z" />
              </svg>
              <p className="mt-2 text-sm font-medium">Instructie-video komt hier</p>
              <p className="mt-1 text-xs">Wordt gepubliceerd zodra de productie-opname klaar is.</p>
            </div>
          </div>
        </div>

        <h2 className="mt-6 text-lg font-semibold">Eerste week — gewenning</h2>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-slate-700">
          <li>Dag 1-2: 2 uur per dag — bij voorkeur in de ochtend.</li>
          <li>Dag 3-4: 4 uur per dag.</li>
          <li>Dag 5-7: 6 uur per dag.</li>
        </ul>

        <h2 className="mt-6 text-lg font-semibold">Tweede week — volledige werkdag</h2>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-slate-700">
          <li>Dag 8-10: 8 uur per dag (volledige werkdag).</li>
          <li>Dag 11-14: hele dag, ook tijdens vrije momenten.</li>
        </ul>

        <h2 className="mt-6 text-lg font-semibold">Aanhoudende klachten?</h2>
        <p className="mt-2 text-sm text-slate-700">
          Heeft u na 14 dagen nog steeds pijn of merkt u dat uw klachten erger worden? Reageer dan op de
          wen-evaluatie-mail die u na 2 weken ontvangt, of mail rechtstreeks naar{" "}
          <a className="text-blue-700 underline" href="mailto:info@fulkraworks.nl">info@fulkraworks.nl</a>.
        </p>
      </div>
    </PageShell>
  );
}
